"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Reservationbutton() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="230328" id="reservationbutton" className="relative min-h-[70vh] flex items-center justify-center overflow-hidden py-24 bg-background text-foreground">
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627813/img/anticosti_landscape_mist.png)] bg-cover bg-center bg-no-repeat grayscale opacity-20 blur-[2px]" />
        <div className="absolute inset-0 bg-background/60" />
      </div>

      <div className="container mx-auto px-4 relative z-10 flex justify-center">
        <div ref={ref} className={`w-full max-w-4xl px-8 py-16 md:py-24 bg-transparent border border-border/30 flex flex-col items-center text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default font-bold tracking-tighter text-foreground max-w-2xl leading-tight uppercase text-3xl ![padding:0px_15px_0px_15px] !m-0 !w-[872px] md:!text-5xl">À PROPOS</h2>
          
          <h3 className="font-default tracking-wider text-foreground/90 mb-6 uppercase text-lg !font-bold md:text-xl">Hébergement Île d'Anticosti</h3>
          
          <ul className="font-default text-foreground/80 mb-8 space-y-2 text-left inline-block">
            <li className="flex items-center gap-2"><span data-ast-id="f:/src/pages/Home/sections/Reservationbutton.tsx|sig:igq8cy" data-ast-start="1747" data-ast-end="1761">•</span> Logement à Port-Menier</li>
            <li className="flex items-center gap-2"><span data-ast-id="f:/src/pages/Home/sections/Reservationbutton.tsx|sig:iflzg0" data-ast-start="1958" data-ast-end="1972">•</span> Condos neufs tout équipés</li>
            <li className="flex items-center gap-2"><span data-ast-id="f:/src/pages/Home/sections/Reservationbutton.tsx|sig:i2xk9t" data-ast-start="2172" data-ast-end="2302">•</span> Hôtel Île d'Anticosti</li>
            <li className="flex items-center gap-2"><span>•</span> À proximité des services et commodités</li>
          </ul>

          <p className="font-default text-foreground/70 max-w-2xl mb-12 leading-relaxed">
            Que ce soit pour quelques jours de vacances, un séjour de pêche, de chasse ou simplement pour décrocher, Les Brises d'Anticosti vous offrent un endroit confortable où vous sentir chez vous. <br />
            <span className="text-xs tracking-widest uppercase mt-4 block">CITQ : 323854</span>
          </p>

          <Button asChild size="lg" className="bg-transparent hover:bg-foreground hover:text-background text-foreground font-default font-medium tracking-widest px-12 py-8 text-lg rounded-md border border-border shadow-md transition-all duration-500 hover:shadow-lg uppercase">
            <Link href="https://brises-anticosti.lodgify.com/fr/toutes-les-proprietes" newTab={true}>
              Réserver
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}